import "./App.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import Footer from "./components/Footer";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Main from "./pages/main";
import Search from "./pages/search";
import Reservation from "./pages/reservation";
import { PersistGate } from "redux-persist/integration/react";
import ReservationList from "./pages/reservationList";
import DriverInfo1V2 from "./pages/driverInfoV2";
import DriverInfo2V2 from "./pages/driverInfo2V2";
import Contract from "./pages/contract";
import Product from "./pages/addInsProduct";
import ResFinal from "./pages/resFinal";
import StandardTerms from "./pages/standardTerms"
import AddEtcProduct from "./pages/addEtcProduct";
import Finish from "./pages/finish";
import React, { useEffect } from "react";
import AdminPay from "./pages/adminPay";
import Loading from "./components/Loading";

const queryClient = new QueryClient();

function App() {

  useEffect(() => {
    // function handleContextMenu(event: MouseEvent) {
    //   event.preventDefault();
    // }

    // if (process.env.REACT_APP_ENV === 'prod') {
    //   document.addEventListener("contextmenu", handleContextMenu);
    // }

    // return () => {
    //   document.removeEventListener("contextmenu", handleContextMenu);

    // };
    document.addEventListener('touchmove', function (e) {
      e.preventDefault(); // 터치 이벤트의 기본 동작(스크롤) 막기
    }, { passive: false });
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <div className="App">
            <div className="root-wrap">
              <BrowserRouter>
                <Loading />
                <Switch>
                  <Route path="/main" component={Main} />
                  <Route path="/search" component={Search} />
                  <Route path="/reservation" component={Reservation} />
                  <Route path="/reservationList" component={ReservationList} />
                  <Route path="/driverInfo" component={DriverInfo1V2} />
                  <Route path="/driverInfo2" component={DriverInfo2V2} />
                  <Route path="/contract" component={Contract} />
                  <Route path="/standard" component={StandardTerms} />
                  <Route path="/addIns" component={Product} />
                  <Route path="/addEtc" component={AddEtcProduct} />
                  <Route path="/resFinal" component={ResFinal} />
                  <Route path="/finish" component={Finish} />
                  <Route
                    path="/adminPay/:userId/:companyId"
                    component={AdminPay}
                  />
                </Switch>{" "}
                <Footer></Footer>
              </BrowserRouter>
            </div>
          </div>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
